export default class customizationCreate {
    constructor() {
        return {
            template: require('../../../../views/customize/modal/customization-create.html'),
            replace: true,
            restrict: 'E',
            scope: {
                groups: '=',
                active: '='
            },
            controller: CustomizationCreateCtrl,
            controllerAs: 'creator'
        }
    }
};

class CustomizationCreateCtrl {
    constructor($scope, $timeout, $filter, Customization, SweetAlert) {
        this._timeout = $timeout;
        this._scope = $scope;
        this._filter = $filter;
        this._translator = $filter('translate');

        this.customRepo = Customization;
        this.alerter = SweetAlert;

        this.initialized = false;
        this.createAnotherField = false;

        this.fieldTypes = [
            { id: 'text', name: this._translator('CUSTOM_FIELDS:TYPE:TEXT')},
            { id: 'multiple', name: this._translator('CUSTOM_FIELDS:TYPE:MULTIPLE')},
            { id: 'datetime', name: this._translator('CUSTOM_FIELDS:TYPE:DATETIME')},
            { id: 'date', name: this._translator('CUSTOM_FIELDS:TYPE:DATE')}
        ];

        this._scope.$watch('active', (newVal) => {
            if (newVal) {
                this.init();
            }
        });
    }

    init() {
        this.group = null;
        this.field = { name: null, type: 'text' };

        this.initialized = true;
    };

    closeModal() {
        this._scope.active = false;
    };

    saveField() {
        let existingGroup = null;
        let fieldType = '';

        angular.forEach(this.fieldTypes, (type) => {
            if (type.id == this.field.type) {
                fieldType = type.id;
            }
        });

        angular.forEach(this._scope.groups, (group) => {
            if (group.name == this.group.name) {
                existingGroup = group;
            }
        });

        if (existingGroup) {
            this.customRepo.storeField(existingGroup.id, this.field.name, this.field.type).then((field) => {
                this.sendNewData(field.data, this.group.name, existingGroup.id, fieldType, false);
            }, (error) => {
                if (error.data.code == 8) {
                    this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:RESERVED_KEYWORD').replace(/:name/, this.field.name));
                } else if (error.data.code == 9) {
                    this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:DUPLICATE_FIELD_UPDATE').replace(/:name/, this.field.name));
                } else if (error.data.code == 10) {
                    this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:FIELD_NAME_INVALID_OR_EMPTY'));
                } else {
                    this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:CREATE_FIELD_ERROR'));
                }
            });
        } else {
            this.customRepo.storeGroup(this.group).then((group) => {
                this.customRepo.storeField(group.data.id, this.field.name, this.field.type).then((field) => {
                    this.sendNewData(field, group.data.name, group.data.id, fieldType, true);
                }, (error) => {
                    if (error.data.code == 8) {
                        this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:RESERVED_KEYWORD').replace(/:name/, this.field.name));
                    } else if (error.data.code == 9) {
                        this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:DUPLICATE_FIELD_UPDATE').replace(/:name/, this.field.name));
                    } else if (error.data.code == 10) {
                        this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:FIELD_NAME_INVALID_OR_EMPTY'));
                    } else {
                        this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:CREATE_FIELD_ERROR'));
                    }
                });
            }, (error) => {
                if (error.data.code == 9) {
                    this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:DUPLICATE_GROUP_UPDATE').replace(/:name/, this.group.name));
                } else if (error.data.name) {
                    this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:ERROR:INVALID_GROUP_NAME'));
                } else if (error.data.code == 10) {
                    this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:GROUP_NAME_INVALID_OR_EMPTY'));
                } else {
                    this.showErrorFeedback(this._filter('translate')('CUSTOMIZE:FLASH:UPDATE_GROUP_ERROR'));
                }
            });
        }
    };

    sendNewData(field, groupName, groupID, fieldType, newGroup) {
        let newData = {
            group: {
                name: groupName,
                id: groupID
            },
            field: field,
            fieldType: fieldType,
            newGroup: newGroup
        };

        if (this.createAnotherField) {
            this._timeout(() => { // Clear selections
                this.init();
            });
        } else {
            this._scope.active = false;
        }

        this._scope.$emit('CustomField:Added', newData);
    };

    showErrorFeedback(message) {
        this.alerter.swal({
            title: this._translator('GLOBAL:FLASH:OOPS'),
            text: message,
            type: 'error'
        });
    };
}
